import { render, staticRenderFns } from "./ExportToExcel.vue?vue&type=template&id=2298701d&scoped=true"
import script from "./ExportToExcel.vue?vue&type=script&lang=js"
export * from "./ExportToExcel.vue?vue&type=script&lang=js"
import style0 from "./ExportToExcel.vue?vue&type=style&index=0&id=2298701d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298701d",
  null
  
)

export default component.exports